export const resetActivityTimer = () => {
    const lastActivityTime = Date.now();
    localStorage.setItem('sessionExpirationTime', lastActivityTime.toString());
};